import {
  TOGGLE_SEARCH_DIALOG
} from './actionTypes'

export const toggleDialog = () => ({type: TOGGLE_SEARCH_DIALOG})
